import React from 'react';
import ParallaxSection from './ParallaxSection';
import { useScrollToContact } from '../hooks/useScrollToContact';

const aircraft = [
  {
    name: 'Ikarus C42',
    category: 'Motorflugzeug',
    description: 'Modernes Ultraleichtflugzeug mit hervorragenden Flugeigenschaften, ideal für die Grundausbildung und Rundflüge.',
  },
  {
    name: 'L23 Super Blanik',
    category: 'Segelflugzeug',
    description: 'Zweisitziges Schulungsflugzeug aus Metall mit guten Flugeigenschaften.',
  },
  {
    name: 'Pirat',
    category: 'Segelflugzeug',
    description: 'Beliebtes Einsitzer-Segelflugzeug für den Vereinsbetrieb.',
  },
];

const Aircraft: React.FC = () => {
  const scrollToContact = useScrollToContact();

  return (
    <ParallaxSection
      id="flugzeuge"
      backgroundImage="/images/Flugsportverein_Bilder_6.jpg"
    >
      <div>
        <div className="lg:text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">Flugzeuge</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Unsere Flotte
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto mb-10">
            Unsere Flugzeuge bieten die perfekte Grundlage für Ihre Flugausbildung.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {aircraft.map((plane) => (
            <div key={plane.name} className="bg-white shadow overflow-hidden rounded-lg p-4 transition-all duration-200 hover:shadow-lg hover:-translate-y-1">
              <span className="inline-block bg-gray-100 rounded-full px-3 py-1 text-sm font-semibold text-gray-600 mr-2 mb-2">
                {plane.category}
              </span>
              <h3 className="text-lg font-medium text-gray-900">{plane.name}</h3>
              <p className="mt-1 text-sm text-gray-500">{plane.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="#kontakt"
            onClick={scrollToContact}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600"
          >
            Interessiert an einem Probeflug? Kontaktieren Sie uns!
          </a>
        </div>
      </div>
    </ParallaxSection>
  );
};

export default Aircraft; 